"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOTIFICATIONS_COPY = void 0;
const GENERIC_1 = require("../../../copy/GENERIC.js");
const EMAILS_1 = require("../../../global/support/EMAILS.js");
exports.NOTIFICATIONS_COPY = {
    ATTACHMENTS_MUST_BE_LESS_THAN_25MB: 'All attachments must be less than 25MB.',
    CONFLICT_POST_TAG: 'Sorry! Tag names must be unique, please use a different tag name',
    ERROR_BULK_TAG: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_CONFIGURE_OKTA: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_CREATE_INITIATVE_TASK: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_CREATING_INITIATIVE: 'Error Creating Initiative',
    ERROR_CUSTOMER_UPDATE: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_DELETE_INITIATIVES: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_DELETE_INITIATIVES_BULK: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_DELETE_INITIATIVES_BY_ID: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_DELETE_INITIATIVES_BY_ID_COMMENTS_BY_ID: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_DELETE_INITIATIVES_BY_INITIATIVE_ID_SONAR_OBJECTS_BY_ID: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_DELETE_INITIATIVE_TASK: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_DELETE_TAG: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_DOWNLOAD_EXPORT: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_DOWNLOAD_INITIATIVE_FILE: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_EMAIL_ALREADY_TAKEN: (link) => 
    // eslint-disable-next-line max-len
    `Welcome back! It looks like this email address is already a Arovy user. Please use a different email address or try logging in <a href="${link}">here</a>.`,
    ERROR_EXPORT_TIMELINE_DETAILS: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_FORGOT_PASSWORD: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_GET_AUTODOC_SUGGESTION: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_GET_AUTODOC_SUGGESTION_FAILED: (entityType) => `Sorry, we're unable to generate a suggestion for this ${entityType}.`,
    ERROR_GET_AUTODOC_SUGGESTION_TITLE: 'Error generating suggestion',
    ERROR_GET_INITIATIVES_BY_ID_FILES_DOWNLOAD: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_GET_USER_INVITE_LINK: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_IMPORT_SUMMARY: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_INTEGRATION_OAUTH: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_LINK_INITIATIVE_TASK_SCOPE: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_LOGIN: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_PATCH_INITIATIVES: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_PATCH_INITIATIVES_BULK: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_PATCH_INITIATIVES_BY_ID: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_PATCH_INITIATIVES_BY_ID_COMMENTS_BY_ID: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_PATCH_USER_CHANGE_EMAIL: 'Unable to save new email, incorrect current password supplied',
    ERROR_PATCH_USER_CHANGE_PASS: 'Unable to save new password, incorrect current password supplied',
    ERROR_PATCH_USER_PREFERENCES: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_PATCH_USER_UPDATE: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_POST_AUTH_ACTIVATE_INVITED_USER: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_POST_DATA_DICTIONARY_EXPORT: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_POST_INITIATIVES_BY_ID_COMMENTS: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_POST_INITIATIVES_BY_ID_FILES: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_POST_INITIATIVES_BY_ID_LINKS: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_POST_INITIATIVES_BY_INITIATIVE_ID_ADD_SF_OBJECT: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_POST_INITIATIVES_BY_INITIATIVE_ID_TASKS: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_POST_INITIATIVE_EXPORT: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    // eslint-disable-next-line max-len
    ERROR_POST_INITIATIVE_JIRA_SYNC: `Oops! Something went wrong. Please double check your Issue in Jira. If the problem persists, please contact ${EMAILS_1.EMAILS.SUPPORT} for more help.`,
    // eslint-disable-next-line max-len
    ERROR_POST_JIRA_INTEGRATION: `Oops! Something went wrong. Please double check your url, username, and token. If the issue persists, please contact ${EMAILS_1.EMAILS.SUPPORT} for more help.`,
    ERROR_POST_ORGANIZATION: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_POST_TAG: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_POST_USER_INVITE: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    // eslint-disable-next-line max-len
    ERROR_PUT_JIRA_INTEGRATION: `Oops! Something went wrong. Please double check your url, username, and token. If the issue persists, please contact ${EMAILS_1.EMAILS.SUPPORT} for more help.`,
    ERROR_PUT_TAG: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_RESET_PASSWORD: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_UNHANDLED: GENERIC_1.COPY_GENERIC.UNHANDLED_ERROR,
    ERROR_UNHANDLED_CONTACT_WITH_MESSAGE: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT_WITH_MESSAGE,
    ERROR_UPDATE_INITIATIVE_TASK: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    ERROR_USER_INVITE: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_BULK_TAG: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_CONFIGURE_OKTA: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_CREATE_INITIATIVE_TASK: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_CUSTOMER_UPDATE: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_DELETE_INITIATIVES: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_DELETE_INITIATIVES_BULK: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_DELETE_INITIATIVES_BY_ID: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_DELETE_INITIATIVES_BY_ID_COMMENTS_BY_ID: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_DELETE_INITIATIVES_BY_INITIATIVE_ID_SONAR_OBJECTS_BY_ID: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_DELETE_INITIATIVE_TASK: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_DELETE_TAG: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_FORGOT_PASSWORD: GENERIC_1.COPY_GENERIC.FORGOT_PASSWORD_INSTRUCTIONS,
    FAILED_GET_INITIATIVES_BY_ID_FILES_DOWNLOAD: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_GET_USER_INVITE_LINK: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_IMPORT_SUMMARY: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_INTEGRATION_OAUTH: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_LINK_INITIATIVE_TASK_SCOPE: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_LOGIN: 'The credentials you entered were incorrect, please try again',
    // eslint-disable-next-line max-len
    FAILED_LOGIN_LOCKED: `Your account has been locked. Please contact your Arovy administrator or reach out to ${EMAILS_1.EMAILS.SUPPORT} for assistance`,
    FAILED_PATCH_INITIATIVES: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_PATCH_INITIATIVES_BULK: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_PATCH_INITIATIVES_BY_ID: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_PATCH_INITIATIVES_BY_ID_COMMENTS_BY_ID: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_PATCH_USER_CHANGE_EMAIL: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_PATCH_USER_CHANGE_PASS: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_PATCH_USER_PREFERENCES: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_PATCH_USER_UPDATE: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_POST_AUTH_ACTIVATE_INVITED_USER: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_POST_DATA_DICTIONARY_EXPORT: GENERIC_1.COPY_GENERIC.TOO_MANY_EXPORTS,
    FAILED_POST_DATA_DICTIONARY_EXPORT_MESSAGE: GENERIC_1.COPY_GENERIC.COULD_NOT_START_EXPORT,
    FAILED_POST_INITIATIVES_BY_ID_COMMENTS: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_POST_INITIATIVES_BY_ID_FILES: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_POST_INITIATIVES_BY_ID_LINKS: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_POST_INITIATIVES_BY_INITIATIVE_ID_ADD_SF_OBJECT: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_POST_INITIATIVES_BY_INITIATIVE_ID_TASKS: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_POST_INITIATIVE_EXPORT: GENERIC_1.COPY_GENERIC.TOO_MANY_EXPORTS,
    FAILED_POST_INITIATIVE_EXPORT_MESSAGE: GENERIC_1.COPY_GENERIC.COULD_NOT_START_EXPORT,
    // eslint-disable-next-line max-len
    FAILED_POST_INITIATIVE_JIRA_SYNC: `Oops! Something went wrong. Please double check your Issue in Jira. If the problem persists, please contact ${EMAILS_1.EMAILS.SUPPORT} for more help.`,
    // eslint-disable-next-line max-len
    FAILED_POST_JIRA_INTEGRATION: `Oops! Something went wrong. Please double check your url, username, and token. If the issue persists, please contact ${EMAILS_1.EMAILS.SUPPORT} for more help.`,
    FAILED_POST_TAG: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_POST_USER_INVITE: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    // eslint-disable-next-line max-len
    FAILED_PUT_JIRA_INTEGRATION: `Oops! Something went wrong. Please double check your url, username, and token. If the issue persists, please contact ${EMAILS_1.EMAILS.SUPPORT} for more help.`,
    FAILED_PUT_TAG: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_RESET_PASSWORD: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_UPDATE_INITIATIVE_TASK: GENERIC_1.COPY_GENERIC.CONTACT_SUPPORT,
    FAILED_USER_INVITE: 'This person is already using Arovy.',
    PREPARING_EXPORT_TIMELINE_DETAILS: 'Preparing Timeline Details for Export',
    STAKEHOLDER_CONFLICT: 'A stakeholder with the same name or email address already exists.',
    SUCCESS_BULK_TAG: 'Successfully tagged',
    SUCCESS_CONFIGURE_OKTA: 'Successfully configured Okta',
    SUCCESS_COPY_INVITE_LINK: 'Successfully copied invite link',
    SUCCESS_COPY_SLACK_LINK: 'Successfully copied Slack link',
    SUCCESS_CREATE_INITIATIVE: 'Successfully Created Initiative',
    SUCCESS_CREATE_INITIATIVE_TASK: 'Successfully Created Task',
    SUCCESS_CUSTOMER_UPDATE: 'Successfully updated customer subdomain',
    SUCCESS_DELETE_INITIATIVES: 'Successfully archived initiatives',
    SUCCESS_DELETE_INITIATIVES_BULK: 'Successfully archived initiatives',
    SUCCESS_DELETE_INITIATIVES_BY_ID: 'Successfully archived initiative',
    SUCCESS_DELETE_INITIATIVES_BY_ID_COMMENTS_BY_ID: 'Successfully deleted comment',
    SUCCESS_DELETE_INITIATIVES_BY_INITIATIVE_ID_SONAR_OBJECTS_BY_ID: 'Successfully Removed Item From Initiative Scope',
    SUCCESS_DELETE_INITIATIVE_TASK: 'Successfully Deleted Task',
    SUCCESS_DELETE_TAG: 'Successfully deleted tag',
    SUCCESS_FORGOT_PASSWORD: GENERIC_1.COPY_GENERIC.FORGOT_PASSWORD_INSTRUCTIONS,
    SUCCESS_IMPORT_SUMMARY: 'Successfully retrieved salesforce import summary',
    SUCCESS_PATCH_APPLICATIONS_BULK: 'Successfully updated applications',
    SUCCESS_PATCH_INITIATIVES: 'Successfully updated initiatives',
    SUCCESS_PATCH_INITIATIVES_BULK: 'Successfully updated initiatives',
    SUCCESS_PATCH_INITIATIVES_BY_ID: 'Successfully edited initiative',
    SUCCESS_PATCH_INITIATIVES_BY_ID_COMMENTS_BY_ID: 'Successfully edited comment',
    SUCCESS_PATCH_USER_CHANGE_EMAIL: 'Successfully changed email',
    SUCCESS_PATCH_USER_CHANGE_PASS: 'Successfully changed password',
    SUCCESS_PATCH_USER_PREFERENCES: 'Successfully updated user preferences',
    SUCCESS_PATCH_USER_UPDATE: 'Successfully updated user',
    SUCCESS_POST_DATA_DICTIONARY_EXPORT: GENERIC_1.COPY_GENERIC.WHEN_EXPORT_COMPLETES,
    SUCCESS_POST_DATA_DICTIONARY_EXPORT_MESSAGE: GENERIC_1.COPY_GENERIC.EXPORT_STARTED,
    SUCCESS_POST_INITIATIVES_BY_ID_COMMENTS: 'Successfully posted comment',
    SUCCESS_POST_INITIATIVES_BY_ID_FILES: 'Successfully Attached File to Initiative',
    SUCCESS_POST_INITIATIVES_BY_ID_LINKS: 'Successfully Added Link to Initiative',
    SUCCESS_POST_INITIATIVES_BY_INITIATIVE_ID_ADD_SF_OBJECT: 'Successfully Added Item to Initiative Scope',
    SUCCESS_POST_INITIATIVES_BY_INITIATIVE_ID_TASKS: 'Successfully Added Item to Initiative Task',
    SUCCESS_POST_INITIATIVE_EXPORT: GENERIC_1.COPY_GENERIC.WHEN_EXPORT_COMPLETES,
    SUCCESS_POST_INITIATIVE_EXPORT_MESSAGE: GENERIC_1.COPY_GENERIC.EXPORT_STARTED,
    SUCCESS_POST_JIRA_INTEGRATION_DESCRIPTION: 'You\'re on your way to a smarter workflow!',
    SUCCESS_POST_JIRA_INTEGRATION_MESSAGE: 'Successfully Connected to Jira',
    SUCCESS_POST_ORGANIZATION: 'Successfully enabled daily syncs',
    SUCCESS_POST_STAKEHOLDER: 'Successfully added new stakeholder.',
    SUCCESS_POST_TAG: 'The tag was created',
    SUCCESS_POST_USER_INVITE: 'The invitation email has been resent',
    SUCCESS_PUT_JIRA_INTEGRATION_DESCRIPTION: 'You have successfully updated your Jira credentials.',
    SUCCESS_PUT_JIRA_INTEGRATION_MESSAGE: 'Successfully Connected to Jira',
    SUCCESS_PUT_SONAR_OBJECTS_STAKEHOLDERS_BULK: 'Successfully added stakeholders',
    SUCCESS_PUT_SONAR_OBJECTS_USERS_BULK: 'Successfully changed owner',
    SUCCESS_PUT_TAG: 'The tag has been updated',
    SUCCESS_RESET_PASSWORD: 'We\'ve updated your password, please login with your new credentials',
    SUCCESS_UPDATE_CUSTOMER_SETTINGS: 'Successfully updated customer settings',
    SUCCESS_UPDATE_INITIATIVE_TASK: 'Successfully Updated Task',
    SUCCESS_USER_INVITE: 'The invite is on its way'
};
//# sourceMappingURL=COPY.js.map